import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import {
  FluentProvider,
  webLightTheme,
  Title1,
  Text,
  Card,
  makeStyles,
  tokens,
} from "@fluentui/react-components";
import { ErrorCircleRegular } from "@fluentui/react-icons";
import "./index.css";
import { loadConfig } from "./config";
import { initializeI18n } from "./i18n/config";
import App from "./App";

// Styles for error page
const useErrorStyles = makeStyles({
  container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "100vh",
    backgroundColor: tokens.colorNeutralBackground3,
  },
  card: {
    maxWidth: "400px",
    paddingTop: tokens.spacingVerticalXXL,
    paddingBottom: tokens.spacingVerticalXXL,
    paddingInline: tokens.spacingHorizontalXXL,
    textAlign: "center",
  },
  icon: {
    fontSize: "48px",
    color: tokens.colorPaletteRedForeground1,
    marginBottom: tokens.spacingVerticalM,
  },
  title: {
    marginBottom: tokens.spacingVerticalM,
  },
  message: {
    color: tokens.colorNeutralForeground2,
  },
});

// Error component for configuration failures
const ConfigurationError = () => {
  const styles = useErrorStyles();

  return (
    <FluentProvider theme={webLightTheme}>
      <div className={styles.container}>
        <Card className={styles.card}>
          <ErrorCircleRegular className={styles.icon} />
          <Title1 className={styles.title}>Configuration Error</Title1>
          <Text className={styles.message}>
            Failed to load application configuration. Please try refreshing the page or contact
            support if the problem persists.
          </Text>
        </Card>
      </div>
    </FluentProvider>
  );
};

// Load runtime configuration and initialize i18n before rendering
loadConfig()
  .then(() => initializeI18n())
  .then(() => {
    createRoot(document.getElementById("root")!).render(
      <StrictMode>
        <App />
      </StrictMode>,
    );
  })
  .catch((error) => {
    console.error("Failed to initialize application:", error);
    createRoot(document.getElementById("root")!).render(
      <StrictMode>
        <ConfigurationError />
      </StrictMode>,
    );
  });
